(() => {
  if (customElements.get('wedding-veils-hub')) return;
  const normalizeLength = value => String(value ?? '').split('(')[0].replace(/\s+/g, '').toLowerCase();
  class WeddingVeilsHub extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.querySelector('[data-wv-filters]');
      this.grid = this.querySelector('[data-wv-grid]');
      this.cards = [...this.querySelectorAll('[data-wv-card]')];
      this.sort = this.querySelector('[data-wv-sort]');
      this.keys = ['style', 'length', 'tiers', 'color'];
      this.cards.forEach((card, index) => {
        card.dataset.order = index;
        try { card.wvVariants = JSON.parse(card.querySelector('[data-wv-variants]')?.textContent || '[]'); } catch { card.wvVariants = []; }
      });
      this.keys.forEach(key => {
        const select = this.form.elements.namedItem(key);
        select.options.length = 1;
        const values = [...new Set(this.cards.flatMap(card => (card.dataset[key] || '').split('|').filter(Boolean)))];
        values.sort((a, b) => key === 'length' ? parseFloat(a) - parseFloat(b) : a.localeCompare(b));
        values.forEach(value => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          select.append(option);
        });
      });
      this.form.hidden = this.cards.length === 0;
      this.filterPanel = this.querySelector('[data-wv-filter-panel]');
      this.filterPanel.hidden = this.cards.length === 0;
      this.desktopMedia = matchMedia('(min-width: 990px)');
      const syncFilterPanel = () => { this.filterPanel.open = this.desktopMedia.matches; };
      syncFilterPanel();
      this.desktopMedia.addEventListener('change', syncFilterPanel, options);
      this.querySelector('[data-wv-sort-wrap]').hidden = this.cards.length === 0;
      this.form.addEventListener('submit', event => event.preventDefault(), options);
      this.form.addEventListener('change', () => this.updateUrl(), options);
      this.sort.addEventListener('change', () => this.updateUrl(), options);
      this.querySelectorAll('[data-wv-clear]').forEach(button => button.addEventListener('click', event => {
        event.preventDefault();
        this.keys.forEach(key => { this.form.elements.namedItem(key).value = ''; });
        if (!this.desktopMedia.matches) this.filterPanel.open = false;
        const url = new URL(location.href);
        const hadNativeFilters = [...url.searchParams.keys()].some(key => key.startsWith('filter.'));
        [...url.searchParams.keys()].filter(key => key.startsWith('filter.')).forEach(key => url.searchParams.delete(key));
        if (hadNativeFilters) {
          this.keys.forEach(key => url.searchParams.delete('wv_' + key));
          url.searchParams.delete('page');
          url.hash = 'wedding-veils-all-products';
          location.assign(url.href);
          return;
        }
        this.updateUrl();
        this.querySelector('.wedding-veils-hub__catalog').scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options));
      window.addEventListener('popstate', () => this.readUrl(), options);
      this.readUrl();
    }
    disconnectedCallback() { this.controller?.abort(); this.ready = false; }
    readUrl() {
      const params = new URL(location.href).searchParams;
      this.keys.forEach(key => {
        const select = this.form.elements.namedItem(key);
        const value = params.get('wv_' + key) || '';
        select.value = [...select.options].some(option => option.value === value) ? value : '';
      });
      this.sort.value = ['price-ascending', 'price-descending', 'title-ascending'].includes(params.get('wv_sort')) ? params.get('wv_sort') : 'original';
      this.render();
    }
    updateUrl() {
      const url = new URL(location.href);
      this.keys.forEach(key => {
        const value = this.form.elements.namedItem(key).value;
        value ? url.searchParams.set('wv_' + key, value) : url.searchParams.delete('wv_' + key);
      });
      this.sort.value === 'original' ? url.searchParams.delete('wv_sort') : url.searchParams.set('wv_sort', this.sort.value);
      url.hash = 'wedding-veils-all-products';
      history.pushState(history.state, '', url);
      this.render();
    }
    render() {
      let count = 0;
      const sort = this.sort.value;
      const cards = [...this.cards].sort((a, b) => {
        if (sort === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
        if (sort === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title);
        return Number(a.dataset.order) - Number(b.dataset.order);
      });
      cards.forEach(card => {
        let visible = this.keys.every(key => {
          const value = this.form.elements.namedItem(key).value;
          return !value || (card.dataset[key] || '').split('|').includes(value);
        });
        const color = this.form.elements.namedItem('color').value;
        const length = this.form.elements.namedItem('length').value;
        if (visible && card.wvVariants.length && (color || length)) visible = card.wvVariants.some(variant => (!color || variant.color.toLowerCase() === color.toLowerCase()) && (!length || normalizeLength(variant.length) === normalizeLength(length)));
        card.hidden = !visible;
        if (visible) count++;
        this.grid.append(card);
      });
      const pagination = this.grid.querySelector('.wedding-veils-hub__pagination');
      if (pagination) this.grid.append(pagination);
      this.querySelector('[data-wv-count]').textContent = (count === 1 ? this.dataset.countOne : this.dataset.countOther).replace('%count%', String(count));
      this.querySelector('[data-wv-empty]').hidden = count > 0 || this.cards.length === 0;
    }
  }
  customElements.define('wedding-veils-hub', WeddingVeilsHub);
})();

